'use client';

import {
  getAppConfig,
  RakbankIslamicLogoIcon,
  RakbankIslamicLogoNoTextIcon,
} from '@bts-web/core-app-config';

interface AppLogoProps {
  size?: number;
  textLogoSize?: number;
  color?: string;
  isIslamicUser?: boolean;
  noText?: boolean;
}

export const DEFAULT_LOGO_SIZE = 25;

const AppLogo = ({
  size = DEFAULT_LOGO_SIZE,
  textLogoSize,
  color,
  isIslamicUser = false,
  noText = false,
}: AppLogoProps) => {
  const { appName, appLogo, appLogoInverted, appId } = getAppConfig();

  const Logo = appId === 4 && appLogoInverted ? appLogoInverted : appLogo;

  if (appName === 'Rakbank' && isIslamicUser) {
    return noText ? (
      <RakbankIslamicLogoNoTextIcon size={size} />
    ) : (
      <RakbankIslamicLogoIcon size={textLogoSize ?? size} />
    );
  }

  return <Logo size={size} color={color} />;
};

export { AppLogo };
